"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = isNumeric;
/* Simple isNumeric, which checks strings as well as numbers
 * - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
 * @param {any} Item to check to see if it's a type of number.
 *
 * @retur {bool}
 */
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/isNumeric.js
// module id = 478
// module chunks = 0